import styled from 'styled-components'

import { Input } from '../text-input/style'

export const StyledTextarea = styled(Input)({
  padding: '13px 18px 11px',
  resize: 'none',
})
